// extracted by mini-css-extract-plugin
export var contentBody = "_co-9";
export var headerImage = "_co-2";
export var imageButton = "_co-7";
export var imageButtonIcon = "_co-8";
export var imageHeader = "_co-4";
export var imageHeaderText = "_co-5";
export var imageOverlay = "_co-3";
export var imageTitle = "_co-6";
export var imageWrapper = "_co-1";
export var taskList = "_co-a";
export var widget = "_co-0";